/* import __COLOCATED_TEMPLATE__ from './option-checkbox.hbs.js'; */
var _dec, _class, _descriptor;
function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
import { readOnly } from '@ember/object/computed';
import Component from '@ember/component';

/*
  Upsell::OptionCheckbox

  @param {String} heading - tooltip heading
  @param {String} description - tooltip description
  @param {String} label - option checkbox label
  @param {String} labelSecondary - (optional) option checkbox secondary label
  @param {String} vertical - The vertical that is using the tooltip.
                             It configures the brand color shown on the components/svgs/plus-badge-filled
                             Available verticals: ['restaurants', 'retail']
  @param {Action} onLearnMoreClick - action called when "Learn more" button is clicked
*/
let OptionCheckbox = (_dec = readOnly('label'), _class = class OptionCheckbox extends Component {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, 'data-test-upsell-option-checkbox', _descriptor, this);
  }
}, _descriptor = _applyDecoratedDescriptor(_class.prototype, 'data-test-upsell-option-checkbox', [_dec], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _class);
export { OptionCheckbox as default };